var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "registrationForm",
      staticClass: "w-100",
      attrs: { autocomplete: "on", method: "post" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validateRegistration()
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            { staticClass: "input-unit", attrs: { "data-validate": "mail" } },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.username,
                    expression: "username"
                  }
                ],
                attrs: {
                  "data-testing": "mail-register",
                  type: "email",
                  name: "email",
                  autocomplete: "email",
                  id: "email" + _vm._uid,
                  "data-autofocus": ""
                },
                domProps: { value: _vm.username },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.username = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "email" + _vm._uid } }, [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.regEmail")) + "*")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        !_vm.guestMode
          ? _c("div", { staticClass: "col-sm-6" }, [
              _c(
                "div",
                {
                  ref: "passwordInput",
                  staticClass: "input-unit",
                  class: { "no-bottom media-xs-d": _vm.modalElement },
                  attrs: { "data-validate": "password" }
                },
                [
                  _c("popper", {
                    ref: "passwordHint",
                    attrs: { trigger: "focus", placement: "bottom" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "handle",
                          fn: function() {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.password,
                                    expression: "password"
                                  }
                                ],
                                attrs: {
                                  "data-testing": "password-register",
                                  type: "password",
                                  name: "password",
                                  autocomplete: "new-password",
                                  id: "new-password-" + _vm._uid
                                },
                                domProps: { value: _vm.password },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  }
                                }
                              })
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintTitle"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "content",
                          fn: function() {
                            return [
                              _c("ul", { staticClass: "pl-3" }, [
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintLength"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintDigit"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.regPasswordHintChar"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      303377206
                    )
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "new-password-" + _vm._uid } }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.regPassword")) +
                        "*"
                    )
                  ])
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.guestMode
          ? _c("div", { staticClass: "col-sm-6 input-unit-group" }, [
              _c(
                "div",
                {
                  staticClass: "input-unit",
                  class: { "no-bottom": _vm.modalElement },
                  attrs: { "data-validate": "ref" }
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordRepeat,
                        expression: "passwordRepeat"
                      }
                    ],
                    attrs: {
                      type: "password",
                      name: "password-repeat",
                      autocomplete: "new-password",
                      id: "new-password-repeat-" + _vm._uid,
                      "data-validate-ref": "#new-password-" + _vm._uid,
                      "data-testing": "repeat-password-register"
                    },
                    domProps: { value: _vm.passwordRepeat },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.passwordRepeat = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "new-password-repeat-" + _vm._uid } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.regRepeatPassword")
                        ) + "*"
                      )
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.honeypot,
              expression: "honeypot"
            }
          ],
          staticClass: "honey",
          attrs: {
            type: "text",
            name: "username",
            autocomplete: "new-password",
            tabindex: "-1"
          },
          domProps: { value: _vm.honeypot },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.honeypot = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            !_vm.isSimpleRegistration
              ? _c("address-input-group", {
                  attrs: {
                    template: "#vue-address-input-group",
                    "address-type": "1",
                    value: _vm.billingAddress,
                    "optional-address-fields": _vm.shownFields,
                    "required-address-fields": _vm.requiredFields,
                    "default-salutation": _vm.defaultSalutation
                  },
                  on: {
                    input: function($event) {
                      return _vm.setAddressDataField($event)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "custom-address-fields",
                        fn: function() {
                          return [_vm._t("custom-address-fields")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.enableConfirmingPrivacyPolicy
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("accept-privacy-policy-check", {
                  staticClass: "mt-3 mb-0",
                  attrs: { "show-error": _vm.privacyPolicyShowError },
                  on: {
                    input: function($event) {
                      return _vm.privacyPolicyValueChanged($event)
                    }
                  },
                  model: {
                    value: _vm.privacyPolicyAccepted,
                    callback: function($$v) {
                      _vm.privacyPolicyAccepted = $$v
                    },
                    expression: "privacyPolicyAccepted"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "border-top mt-2 text-right" },
        [
          _vm._t("extend-overlay-buttons"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-appearance btn-primary btn-medium mt-3",
              class: _vm.buttonSizeClass,
              attrs: {
                disabled: _vm.isDisabled,
                "data-testing": "register-submit"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$translate("Ceres::Template.regRegister")) +
                  "\n            "
              ),
              _c("icon", {
                staticClass: "default-float",
                attrs: { icon: "user-plus", loading: _vm.isDisabled }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      !!_vm.googleRecaptchaApiKey &&
      (_vm.modalShown || !_vm.isSimpleRegistration)
        ? _c("recaptcha")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }